import { render, staticRenderFns } from "./AddressEditDialog.vue?vue&type=template&id=6a6a4b04&"
import script from "./AddressEditDialog.vue?vue&type=script&lang=js&"
export * from "./AddressEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports